<main class="menu-card">
  <section class="sheet-handle" cdkFocusInitial tabindex="-1" aria-hidden="true"></section>

  <button class="menu-item pill profile" (click)="close('profile')">
    <span class="icon"></span>
    <span class="label">Profil</span>
  </button>

  <button class="menu-item pill logout" (click)="close('logout')">
    <span class="icon"></span>
    <span class="label">Log out</span>
  </button>
</main>
